import { createReducer } from 'reduxsauce';
import { isEqual, cloneDeep, filter, findIndex } from 'lodash';

import { TodoListTypes } from '../actions/todolist.actions';

const initialState = {
  status: [],
  allTodoChecklists: [],
  todoChecklists: [],
  filter: {},
  commissionRequests: [],
};

const getTodoChecklistRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-todo-checklist');

  return { ...state, status };
};
const getTodoChecklistSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-todo-checklist', a));

  return {
    ...state,
    allTodoChecklists: action.response,
    todoChecklists: action.response,
    status,
  };
};
const getTodoChecklistFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-todo-checklist', a));

  return { ...state, status };
};

const submitTodoChecklistRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-submit-todo-checklist-${action.checklistId}`);

  return { ...state, status };
};
const submitTodoChecklistSuccess = (state, action) => {
  const checklist = action.response;

  const allTodoChecklists = cloneDeep(state.allTodoChecklists);
  const todoChecklists = cloneDeep(state.todoChecklists);
  const idxInAllTodoChecklists = findIndex(allTodoChecklists, (e) => isEqual(e.id, checklist.id));
  if (idxInAllTodoChecklists > -1) {
    allTodoChecklists[idxInAllTodoChecklists] = checklist;
  }
  const idxInTodoChecklists = findIndex(todoChecklists, (e) => isEqual(e.id, checklist.id));
  if (idxInTodoChecklists > -1) {
    todoChecklists[idxInTodoChecklists] = checklist;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-submit-todo-checklist-${checklist.id}`, a));

  return {
    ...state,
    allTodoChecklists,
    todoChecklists,
    status,
  };
};
const submitTodoChecklistFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-submit-todo-checklist-${action.checklistId}`, a));

  return { ...state, status };
};

const getTodoListWithFilterRequest = (state, action) => {
  const { column, value } = action;
  const { allTodoChecklists } = state;
  if (column === '' || value === '') {
    return {
      ...state,
      todoChecklists: allTodoChecklists,
      filter: {},
    };
  }
  const filteredChecklists = allTodoChecklists.filter((checklist) => checklist[column] === value);

  return {
    ...state,
    todoChecklists: filteredChecklists,
    filter: {
      column,
      value,
    },
  };
};

const updateChecklistCommentRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-update-checklistcomment-${action.commentId}`);

  return { ...state, status };
};
const updateChecklistCommentSuccess = (state, action) => {
  const { comment } = action.response;

  const allTodoChecklists = cloneDeep(state.allTodoChecklists);
  const todoChecklists = cloneDeep(state.todoChecklists);
  allTodoChecklists.forEach((checklist, index) => {
    const { comments } = checklist;
    const idx = findIndex(comments, (e) => isEqual(e.id, comment.id));
    if (idx > -1) {
      comments[idx] = comment;
    }
    allTodoChecklists[index].comments = comments;
  });
  todoChecklists.forEach((checklist, index) => {
    const { comments } = checklist;
    const idx = findIndex(comments, (e) => isEqual(e.id, comment.id));
    if (idx > -1) {
      comments[idx] = comment;
    }
    todoChecklists[index].comments = comments;
  });

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-update-checklistcomment-${comment.id}`, a));

  return {
    ...state,
    allTodoChecklists,
    todoChecklists,
    status,
  };
};
const updateChecklistCommentFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-update-checklistcomment-${action.commentId}`, a));

  return { ...state, status };
};

const deleteChecklistCommentRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-delete-checklistcomment-${action.commentId}`);

  return { ...state, status };
};
const deleteChecklistCommentSuccess = (state, action) => {
  const { commentId } = action;

  const allTodoChecklists = cloneDeep(state.allTodoChecklists);
  const todoChecklists = cloneDeep(state.todoChecklists);
  allTodoChecklists.forEach((checklist, index) => {
    let { comments } = checklist;
    comments = filter(comments, (e) => !isEqual(e.id, commentId));
    allTodoChecklists[index].comments = comments;
  });
  todoChecklists.forEach((checklist, index) => {
    let { comments } = checklist;
    comments = filter(comments, (e) => !isEqual(e.id, commentId));
    todoChecklists[index].comments = comments;
  });

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-checklistcomment-${commentId}`, a));

  return {
    ...state,
    allTodoChecklists,
    todoChecklists,
    status,
  };
};
const deleteChecklistCommentFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-checklistcomment-${action.commentId}`, a));

  return { ...state, status };
};

const getUsersCustomCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-commission-requests');

  return { ...state, status };
};
const getUsersCustomCommissionsSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-commission-requests', a));

  return {
    ...state,
    commissionRequests: action.response,
    status,
  };
};
const getUsersCustomCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-commission-requests', a));

  return { ...state, status };
};

const approveCustomCommissionRequest = (state, action) => {
  const { commissionId } = action;

  const status = cloneDeep(state.status);
  status.push(`pending-approve-custom-commission-${commissionId}`);

  return { ...state, status };
};
const approveCustomCommissionSuccess = (state, action) => {
  const { commissionId } = action;

  let commissionRequests = cloneDeep(state.commissionRequests);
  commissionRequests = filter(commissionRequests, (c) => !isEqual(c.id, commissionId));

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-approve-custom-commission-${commissionId}`, a));

  return { ...state, commissionRequests, status };
};
const approveCustomCommissionFailure = (state, action) => {
  const { commissionId } = action;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-approve-custom-commission-${commissionId}`, a));

  return { ...state, status };
};

const declineCustomCommissionRequest = (state, action) => {
  const { commissionId } = action;

  const status = cloneDeep(state.status);
  status.push(`pending-decline-custom-commission-${commissionId}`);

  return { ...state, status };
};
const declineCustomCommissionSuccess = (state, action) => {
  const { commissionId } = action;

  let commissionRequests = cloneDeep(state.commissionRequests);
  commissionRequests = filter(commissionRequests, (c) => !isEqual(c.id, commissionId));

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-decline-custom-commission-${commissionId}`, a));

  return { ...state, commissionRequests, status };
};
const declineCustomCommissionFailure = (state, action) => {
  const { commissionId } = action;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-decline-custom-commission-${commissionId}`, a));

  return { ...state, status };
};

const clearTodoListRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [TodoListTypes.GET_TODO_CHECKLIST_REQUEST]: getTodoChecklistRequest,
  [TodoListTypes.GET_TODO_CHECKLIST_SUCCESS]: getTodoChecklistSuccess,
  [TodoListTypes.GET_TODO_CHECKLIST_FAILURE]: getTodoChecklistFailure,

  [TodoListTypes.SUBMIT_TODO_CHECKLIST_REQUEST]: submitTodoChecklistRequest,
  [TodoListTypes.SUBMIT_TODO_CHECKLIST_SUCCESS]: submitTodoChecklistSuccess,
  [TodoListTypes.SUBMIT_TODO_CHECKLIST_FAILURE]: submitTodoChecklistFailure,

  [TodoListTypes.UPDATE_CHECKLIST_COMMENT_REQUEST]: updateChecklistCommentRequest,
  [TodoListTypes.UPDATE_CHECKLIST_COMMENT_SUCCESS]: updateChecklistCommentSuccess,
  [TodoListTypes.UPDATE_CHECKLIST_COMMENT_FAILURE]: updateChecklistCommentFailure,

  [TodoListTypes.DELETE_CHECKLIST_COMMENT_REQUEST]: deleteChecklistCommentRequest,
  [TodoListTypes.DELETE_CHECKLIST_COMMENT_SUCCESS]: deleteChecklistCommentSuccess,
  [TodoListTypes.DELETE_CHECKLIST_COMMENT_FAILURE]: deleteChecklistCommentFailure,

  [TodoListTypes.GET_TODO_LIST_WITH_FILTER_REQUEST]: getTodoListWithFilterRequest,

  [TodoListTypes.GET_USERS_CUSTOM_COMMISSIONS_REQUEST]: getUsersCustomCommissionsRequest,
  [TodoListTypes.GET_USERS_CUSTOM_COMMISSIONS_SUCCESS]: getUsersCustomCommissionsSuccess,
  [TodoListTypes.GET_USERS_CUSTOM_COMMISSIONS_FAILURE]: getUsersCustomCommissionsFailure,

  [TodoListTypes.APPROVE_CUSTOM_COMMISSION_REQUEST]: approveCustomCommissionRequest,
  [TodoListTypes.APPROVE_CUSTOM_COMMISSION_SUCCESS]: approveCustomCommissionSuccess,
  [TodoListTypes.APPROVE_CUSTOM_COMMISSION_FAILURE]: approveCustomCommissionFailure,

  [TodoListTypes.DECLINE_CUSTOM_COMMISSION_REQUEST]: declineCustomCommissionRequest,
  [TodoListTypes.DECLINE_CUSTOM_COMMISSION_SUCCESS]: declineCustomCommissionSuccess,
  [TodoListTypes.DECLINE_CUSTOM_COMMISSION_FAILURE]: declineCustomCommissionFailure,

  [TodoListTypes.CLEAR_TODO_LIST_REQUEST]: clearTodoListRequest,
});
